import React from 'react';
export function FiveReasonsHeader() {
  return <section className="bg-[#0a0a0a] pt-12 sm:pt-20 pb-6 sm:pb-10 px-6 relative border-t border-gray-900/60" data-id="element-75">
      <div className="max-w-4xl mx-auto text-center flex flex-col items-center gap-6" data-id="element-76">
        {/* Transition tag */}
        <p className="text-[#d4a85a] uppercase tracking-[0.25em] text-[11px] sm:text-xs font-semibold" data-id="element-77">
          Inside the Book
        </p>

        {/* Title */}
        <h2 className="font-serif text-4xl sm:text-5xl lg:text-6xl text-[#e8e2d4] font-normal leading-tight" data-id="element-78">
          Five reasons to read it
        </h2>
      </div>
    </section>;
}